<template>
    <module-card :nextFunction="requestPermissions">
        <p class="text-h6 text-center">Get a Clue!</p>
        <p>
            Here's another game to challenge your BottomLine. Hit the Spin It! button to get a random sexy situation, and hit next. Then select what you would do to maintain your BottomLine! You'll have 3 rounds to finish the game!
        </p>
    </module-card>
</template>

<script>
    export default {
        methods: {
            requestPermissions() {
                //TODO: need to request device motion permissions to get device shaking to work on iOS
            }
        }
    };
</script>
